export class AddItemFromTemplateError extends Error {
  constructor(message: string = 'Failed to add item to inspection template') {
    super(message);
    this.name = 'AddItemFromTemplateError';
  }
}
